import React from 'react';
import { defaultStrings } from 'js/config/config';
import { mapStore } from 'stores/MapStore';
import { mapActions } from 'actions/MapActions';

export class LockedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = mapStore.getState();
    mapStore.listen(this.onChange.bind(this));
  }

  onChange() {
    this.setState(mapStore.getState());
  }

  closeModal() {
    mapActions.setLockedModalVisibility(false);
  }

  render() {
    const showLockedModal = this.state.showLockedModal ? '' : 'hidden';
    return (
      <div className={`details-popup-wrapper ${showLockedModal}`}>
        <div id={'lockedPopup'} className={'details-popup'}>
          <div className='popup-header blue darken-3 welcome-header'>
            <span>Subscribe for Premium Features</span>
            <span className='details-popup-close-icon' onClick={this.closeModal.bind(this)} />
          </div>
          <div className='popup-body padding welcome-body flex flex-column'>
            <div>{defaultStrings.subscribeModalText}</div>
            <a
              href={defaultStrings.subscribePage}
              target='_blank'
              className='waves-effect waves-light btn blue darken-3 button-margin'
            >
              Subscribe
            </a>
          </div>
        </div>
      </div>
    );
  }
}
